import { useLayoutEffect, useRef, useState } from "react";

// Unfortunately, https://github.com/davidtheclark/react-aria-menubutton
// doesn't support absoulte positioning of the pop-up menu, and
// https://react-spectrum.adobe.com/react-aria/useMenuTrigger.html
// is overly complicated. So we're just doing a brain-dead
// drop menu with no accessibility until we have more time...

export default function DropMenu({ children: render, margin = 4, position = "right" }) {
    const [isOpen, setIsOpen] = useState(false),
        close = () => setIsOpen(false),
        toggle = event => {
            event.stopPropagation();
            setIsOpen(o => !o);
        };

    const buttonRef = useRef(),
        menuRef = useRef();

    useLayoutEffect(() => {
        const menu = menuRef.current;
        if (menu) {
            // Adjust the position of the menu relative to the trigger
            // button, while making sure it stays within the bounds of
            // the window.
            const menuRect = menu.getBoundingClientRect(),
                { height: menuHeight } = menuRect,
                buttonRect = buttonRef.current.getBoundingClientRect(),
                { top: buttonTop, left: buttonLeft, width: buttonWidth } = buttonRect,
                top = Math.max(margin, Math.min(buttonTop, window.innerHeight - menuHeight));

            console.log(buttonRect);

            // TODO: a more generic way to position. these are pretty specific
            // to the places they are currently used in the UI.
            menu.style.position = "absolute";
            if (position == "right") {
                menu.style.top = `${top}px`;
                menu.style.left = `${buttonLeft + buttonWidth + margin}px`;
            } else {
                menu.style.top = `${buttonTop + buttonWidth + margin}px`;
                menu.style.right = `${margin}px`;
            }
        }
    }, [isOpen, margin, position]);

    const handleBlur = event => {
        const target = event.target;

        // We need to wait a tick for the event to finish
        // in order for the activeElement to actually change
        setTimeout(() => {
            const active = target.ownerDocument.activeElement;
            if (active == target) return;
            if (active == menuRef.current) return;
            if (menuRef.current?.contains(active)) return;
            close();
        }, 0);
    };

    const handleClick = callback => event => {
        callback && callback(event);
        close();
    };

    const renderArg = {
        isOpen,
        createWrapperProps(props = {}) {
            return {
                ...props
            };
        },
        createButtonProps(props = {}) {
            return {
                ...props,
                ref: buttonRef,
                role: "button",
                tabIndex: 0,
                "aria-haspopup": true,
                "aria-expanded": isOpen,
                onClick: toggle,
                onBlur: handleBlur
            };
        },
        createMenuProps(props = {}) {
            return {
                ...props,
                ref: menuRef,
                role: "menu",
                tabIndex: -1
            };
        },
        createItemProps({ onClick, ...props } = {}) {
            return {
                ...props,
                onClick: handleClick(onClick),
                role: "menuitem",
                tabIndex: -1
            };
        }
    };
    return render ? render(renderArg) : null;
}
